import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Context } from '../context/Context';
import axios from 'axios';
import { getHeaders, base } from '../Config';
import queryString from 'query-string';
import sermonTextBg from '../assets/sermon-text-background.svg';
import sermonPlay from '../assets/sermon-play.svg';
import sermonPause from '../assets/sermon-pause.svg';

export default function Sermon() {
    const { lang, theme, handleShowLoader } = useContext(Context);
    const [activeTab, setActiveTab] = useState('sub1');
    const [sermonData, setSermonData] = useState(null);
    const [currentPlaying, setCurrentPlaying] = useState(null);
    const [audioRef, setAudioRef] = useState(null);
    const history = useHistory();
    const location = useLocation();
    
    // Get language from URL params
    const params = queryString.parse(location.search);
    const selectedLang = params.lang || lang;

    useEffect(() => {
        fetchSermonData();
        return () => {
            localStorage.removeItem('sermonTitle');
        };
    }, [selectedLang]);

    const fetchSermonData = async () => {
        handleShowLoader(true);
        try {
            const response = await axios({
                method: 'post',
                url: base + 'sermon',
                headers: { ...getHeaders(), Language: selectedLang },
            });
            console.log('Sermon data:', response.data);
            console.log('Language used:', selectedLang);
            setSermonData(response.data);
            localStorage.setItem('sermonTitle',response.data.title)
        } catch (error) {
            console.error('Error fetching sermon data:', error);
        } finally {
            handleShowLoader(false);
        }
    };

    const handlePlayPause = (id, url) => {
        if (currentPlaying === id) {
            // Pause current audio
            if (audioRef) {
                audioRef.pause();
            }
            setCurrentPlaying(null);
        } else {
            // Stop previous audio if any
            if (audioRef) {
                audioRef.pause();
            }
            
            // Play new audio
            const audio = new Audio(url);
            audio.play();
            setAudioRef(audio);
            setCurrentPlaying(id);
            
            // Reset when audio ends
            audio.onended = () => {
                setCurrentPlaying(null);
            };
        }
    };

    const renderSermonItem = (item, index) => {
        const isPlaying = currentPlaying === item.id;
        
        return (
            <div 
                key={index}
                className='relative mb-6 cursor-pointer flex items-center justify-center'
                onClick={() => handlePlayPause(item.id, item.url)}
                style={{ height: '80px' }}
            >
                {/* Sermon Background Banner */}
                <img 
                    src={sermonTextBg} 
                    alt="" 
                    className='absolute inset-0 w-full h-full object-contain'
                    style={{ maxWidth: '100%' }}
                />
                
                {/* Title */}
                <span className='relative z-10 text-black font-bold text-lg px-12 text-center'>
                    {item.title || 'Sermon du Jour'}
                </span>
                
                {/* Play/Pause Button */}
                <img 
                    src={isPlaying ? sermonPause : sermonPlay}
                    alt={isPlaying ? "Pause" : "Play"}
                    className='absolute w-20 h-20'
                    style={{ 
                        right: '-10px',
                        zIndex: 20,
                        filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.3))'
                    }}
                />
            </div>
        );
    };

    return (
        <div className='min-h-screen bg-cover bg-center bg-no-repeat bg-green_bg_pic'>

            {/* Tabs */}
            <div className='grid grid-cols-2 pt-[3.4rem]'>
                <button
                    onClick={() => setActiveTab('sub1')}
                    className={`py-4 text-center font-semibold transition-colors ${
                        activeTab === 'sub1'
                            ? 'bg-gradient-to-b from-[#344F16] via-[#6A6F1C] to-[#D4A648] text-black'
                            : 'bg-black text-white'
                    }`}
                >
                    {sermonData?.sub1?.title || 'Sermon of the Day'}
                </button>
                <button
                    onClick={() => setActiveTab('sub2')}
                    className={`py-4 text-center font-semibold transition-colors ${
                        activeTab === 'sub2'
                            ? 'bg-gradient-to-b from-[#344F16] via-[#6A6F1C] to-[#D4A648] text-black'
                            : 'bg-black text-white'
                    }`}
                >
                    {sermonData?.sub2?.[0]?.title || 'Past Sermons'}
                </button>
            </div>

            {/* Content */}
            <div className='p-4 pt-6'>
                {activeTab === 'sub1' && sermonData?.sub1?.data && (
                    <div>
                        {sermonData.sub1.data.map((item, index) => renderSermonItem(item, index))}
                    </div>
                )}

                {activeTab === 'sub2' && sermonData?.sub2?.[0]?.data && (
                    <div>
                        {sermonData.sub2[0].data.map((item, index) => renderSermonItem(item, index))}
                    </div>
                )}
            </div>
        </div>
    );
}
